import { priceNumber } from '../parsers/extract-numbers';
export default ((min, {
  message = `This field should be at least ${min}`,
  isPriceNumber = false
} = {}) => value => {
  const number = isPriceNumber ? priceNumber(value) : parseFloat(value);
  if (isPriceNumber && (value === '' || value == null) || Number.isNaN(number) || number < min) return message;
  return null;
});